import { Component, ElementRef, inject } from '@angular/core';
import { NgForOf, NgIf, NgTemplateOutlet } from '@angular/common';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import { DebounceClickDirective } from '@uzurv/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { AbstractPaymentAccountForm } from '../abstract-payment-account-form';
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { FocusUtil } from '../../../../utils';

@Component({
  selector: 'app-mobility-manager-payment-account-form',
  templateUrl: './mobility-manager-payment-account-form.component.html',
  styleUrls: ['./mobility-manager-payment-account-form.component.scss'],
  imports: [
    CreditCardDirectivesModule,
    DebounceClickDirective,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatOptionModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    NgForOf,
    NgIf,
    ReactiveFormsModule,
    NgTemplateOutlet,
    MatDatepickerModule
  ],
  standalone: true
})
export class MobilityManagerPaymentAccountFormComponent extends AbstractPaymentAccountForm {
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  // Overriding to allow for the Save button to trigger validation.
  override submitPaymentAccount(): void {
    if (this.creditCardForm.invalid) {
      this.creditCardForm.markAllAsTouched();
      FocusUtil.focusFirstInvalidFormControl(this.elementRef.nativeElement);
      return;
    }
    super.submitPaymentAccount();
  }

  get expPickerDate(): Date | null {
    const expDate = this.creditCardForm.controls.cardExpiration.value;
    if (!expDate) {
      return null;
    }
    const [mm, yyyy] = expDate.split('/').map(Number);
    return new Date(yyyy, mm - 1, 1);
  }

  onMonthSelected(value: Date, picker: MatDatepicker<Date>): void {
    const mm = String(value.getMonth() + 1).padStart(2, '0');
    const yyyy = value.getFullYear();
    this.creditCardForm.controls.cardExpiration.setValue(`${mm}/${yyyy}`);
    this.creditCardForm.controls.cardExpiration.markAsTouched();
    picker.close();
  }
}
